<template>
    <div class="billing">
        <CurrentPlans />
        <Plans />
        <FeaturePlans />
        <PaymentMethod />
        <Invoices />
    </div>
</template>
<script>
import CurrentPlans from "./components/CurrentPlans.vue";
import Plans from "./components/Plans.vue";
import FeaturePlans from "./components/FeaturePlans.vue";
import Invoices from "./components/Invoices.vue";
import PaymentMethod from "./components/PaymentMethod.vue";

export default {
    name: "Billing",
    components: { PaymentMethod, Invoices, FeaturePlans, CurrentPlans, Plans },
};
</script>
<style lang="scss" scoped>
.billing {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 30px;
}
</style>
